module.exports = "/virtual-football-league/img/video/clubs/germany/dortmund.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/germany/dortmund.png
// module id = 344
// module chunks = 4